
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.517 24H3.871c.522-3.035.897-6.162-.422-8.028C1.783 13.615 1.019 11.23 1 9.089.955 3.899 5.231-.025 11.203 0c7.236.03 9.328 6.156 9.773 7.943.34 1.369-.898 1.869-.166 2.702.596.679 1.035 1.364 1.789 2.177.292.315.405.646.401.943-.006.434-.291.798-.748.958-.429.15-.76.32-1.215.443-.145 1.16-.521 2.572-.798 3.557-.737 2.62-2.896 1.059-3.881 2.607-.426.668-.64 1.738-.841 2.67zm-4.293-8.316a.47.47 0 00.307-.109l.594-.391h-2.25l.594.391c.077.069.19.109.308.109h.447zm.922-1a.25.25 0 000-.5H9.867a.25.25 0 000 .5h2.279zm.247-1c0-2.003 1.607-2.83 1.607-4.614 0-1.86-1.501-2.886-3.001-2.886S8 7.208 8 9.07c0 1.784 1.607 2.639 1.607 4.614h2.786zm2.477-3.615l1.349.612-.413.911-1.299-.588c.151-.3.276-.608.363-.935zm-7.739 0c.087.332.208.631.36.935l-1.296.588-.414-.911 1.35-.612zm9.369-.885v-1h-1.594c.073.327.103.665.093 1H16.5zm-9.498 0v-.003c-.01-.334.02-.67.092-.997H5.5v1h1.502zm7.02-2.714l1.242-.882.579.816-1.252.888a3.66 3.66 0 00-.569-.822zm-6.044-.001c-.23.252-.418.525-.569.823l-1.251-.888.578-.816 1.242.881zm4.435-1.046l.663-1.345.897.443-.664 1.345a4.063 4.063 0 00-.896-.443zm-2.826-.001c-.315.11-.618.258-.897.442l-.663-1.343.897-.443.663 1.344zm1.913-.208a4.233 4.233 0 00-1-.001V3.684h1v1.53z"}})])
          )
        }
      }
    